<div class="comparisonWrap">
    <div class="trinkavsGarmmarlyBanner">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="bannerContent">
                        <h1>Procurando por uma <br /> alternativa gramatical?</h1>
                        <p>Mude do Grammarly Premium para a Trinka sem perder sua taxa de assinatura!</p>
                        <div class="bannerContentButtons try_a_free_form">
                            <!-- <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank" class="itsFreeButton">Use a Trinka gratuitamente
                        </a>
                        <span class="orTrydemoButton">
                            <a [routerLink]="['/try-a-demo']">
                                ou experimente a versão demo
                            </a>
                        </span> -->
                            <form [formGroup]="compareTrinkaGrammarly" (ngSubmit)="onSubmitEmail()">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group" [ngClass]="(!compareTrinkaGrammarly.get('userEmailId').valid && compareTrinkaGrammarly.get('userEmailId').dirty) || (compareTrinkaGrammarly.get('userEmailId').touched && compareTrinkaGrammarly.get('userEmailId').pristine) ? 'TextFiledError' : '' ">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Digite seu E-mail *</mat-label>
                                                <input id="contactUserEmail" matInput placeholder="" formControlName="userEmailId" class="form-control">
                                            </mat-form-field>
                                            <button type="submit">Experimente grátis</button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="grammarlyTestimonials">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonialsContent">
                    <img src="../../../assets/images/double_quotes_icon.png" alt="icon">
                    <p>Esta ferramenta de verificação gramatical de IA supera o Grammarly! Verifiquei novamente alguns documentos
                        que verifiquei anteriormente com o Grammarly. Fiquei agradavelmente surpreso ao ver um produto tão
                        único da Índia, definitivamente uma alternativa melhor do Grammarly.</p>
                    <h3>Radiologista, Índia</h3>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="switch_from_grammarly custom_width">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="grammarly_premium switchFromTrinka">
                    <h2>Mudar do Grammarly Premium</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Você já se inscreveu no Grammarly premium, mas está procurando uma alternativa melhor? Você pode facilmente
                        mudar seu saldo Grammarly Premium para Trinka Premium!</p>
                    <div class="sample_exmple">
                        <p>
                            <b>Exemplo de plano anual Grammarly Premium</b>
                        </p>
                        <p>Data de início premium: 5 de janeiro de 2021</p>
                        <p>Data de hoje: 25 de abril de 2021</p>
                        <p>Dias grátis adicionais que você terá: 255 dias</p>
                    </div>
                    <div class="how_it_work">
                        <a (click)="scroll(target)" class="itsFreeButton">Veja como funciona</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="free_premium">
                    <div class="free_premium_border">
                        <div class="discount-label yellow">
                            <span>Oferta especial</span>
                        </div>
                        <div class="free_premium_title">
                            Calculadora de extensão
                            <br>premium gratuita
                        </div>
                        <i>Use esta calculadora para descobrir a extensão de assinatura premium gratuita que você receberá ao
                            mudar de Grammarly para Trinka.</i>
                        <div class="free_premium_form">
                            <!-- <form> -->
                            <div class="textbox_content form-group">
                                <label>Data de início Grammarly Premium:
                                </label>
                                <input placeholder="MM/DD/YY" type="date" class="form-control" (change)="premiumDateChanged($event)">
                                <label>Tipo de Plano:</label>
                                <select class="custom-select" [ngModel]="grammarlySelect" (change)="planTypeChanged($event)">
                                    <option selected value="">Tipo de Plano
                                    </option>
                                    <option value="M">Anual</option>
                                    <option value="Y">Mensal</option>
                                </select>
                            </div>
                            <!-- </form> -->
                            <p *ngIf="finalTextContent" class="form_status">Você receberá
                                <span>{{diffDays}}</span> dias adicionais se comprar o plano anual Trinka Premium hoje.({{currentDate
                                | date:'dd-MM-yyyy'}})
                            </p>
                            <!-- <h3>Example for Grammarly Premium Annual Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 April 2021</p> 
                            <p>Addition free days you will get: 255 days</p> 
                            <h3 class="mart15">Example for Grammarly Premium Monthly Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 January 2021</p> 
                            <p>Addition free days you will get: 20 days</p>  -->
                        </div>
                        <span class="validTextSection">*válido em pagamentos apenas por cartões de débito/crédito</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="compare_tables_discriptions">
                    <h2>Trinka vs. Grammarly: Uma comparação detalhada</h2>
                    <div class="HeadingSubLine"></div>
                    <p>A tabela resume como a Trinka, uma nova era de gramática de IA e ferramenta de aprimoramento de linguagem,
                        supera Grammarly em verificações gramaticais avançadas, verificações ortográficas, sintaxe, tom e
                        outros aprimoramentos de escrita.</p>
                </div>
                <div class="compare_tabels table-responsive">
                    <table class="table">
                        <tr>
                            <th>Recursos</th>
                            <th>Trinka</th>
                            <th>Grammarly</th>
                        </tr>
                        <tr>
                            <td>
                                Guias de estilo acadêmico
                                <b>(como APA, AMA e mais) </b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="cancel icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Correções baseadas na área de assunto
                                <b>(Medicina, Ciências da Vida, Engenharia e muito mais)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="cancel icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Ortografia Técnica
                                <b>(Correções ortográficas com base no assunto) </b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="cancel icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Frase Técnica
                                <b>(Escrita adequada ao seu assunto) </b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="cancel icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Linguagem vaga
                                <b>(deixe sua escrita clara e específica)
                                </b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="cancel icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Verificações de preparação para publicação
                                <b>(evaluates on 20+ checkpoints for publication success)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="cancel icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Edição automática de arquivo
                                <b>(Edite arquivos do MS Word automaticamente em minutos)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="cancel icon">
                            </td>
                        </tr>

                        <tr>
                            <td>
                                Tom formal / acadêmico
                                <b>(incluindo coloquialismos, verbos frasais informais e expressões idiomáticas)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <span class="LimitedContent">limitada
                                    <button class="tooltip_section AcademicTone" alt="Restrito a alguns tipos de recursos de tom acadêmico, como contrações, pronomes de primeira pessoa e voz passiva. Além disso, Trinka também cobre coloquialismos e verbos frasais informais e expressões idiomáticas.">
                                        <img src="../../../assets/images/info.svg" alt="info icon" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>Redução da contagem de palavras
                                <b>(Torna a escrita concisa e poderosa) </b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <span class="LimitedContent">limitada
                                    <button class="tooltip_section" alt="Restrito a alguns tipos de recursos de concisão, como preposições compostas e redundância. Trinka mostra como fazer nominalizações concisas e diretas e ajuda a reduzir a contagem de palavras usando não apenas palavras, mas também pontuação.">
                                        <img src="../../../assets/images/info.svg" alt="info icon" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>Linguagem imparcial
                                <b>(Linguagem inclusiva, em primeiro lugar, não sexista)
                                </b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <span class="LimitedContent">limitada
                                    <button class="tooltip_section UnbiasedLanguage" alt="Restrito a alguns tipos de recursos de linguagem imparciais, como linguagem inclusiva. Trinka cobre isso e também garante que sua escrita reflita uma linguagem de gênero neutro em primeiro lugar.">
                                        <img src="../../../assets/images/info.svg" alt="info icon" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Verificação de Plágio
                                <b>(compara com conteúdo da Internet, de Acesso Aberto e publicações pagas)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td  class="single-line-tootltip">
                                <span class="LimitedContent">limitada
                                    <button class="tooltip_section UnbiasedLanguage" alt="Não inclui conteúdo de publicações pagas">
                                        <img src="../../../assets/images/info.svg" alt="info icon" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Verificações de consistência
                                <b>(Traços, grafias, números e mais) </b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Aceitar e ignorar todas as alterações
                                <b>(com um clique, aplique ou ignore várias sugestões)
                                </b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Verificações gramaticais avançadas</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Correção da estrutura da frase</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Escolha de palavras</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Estilo inglês dos EUA / Reino Unido</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Explicações detalhadas e dicas</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Dicionário Pessoal</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Editor Online</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Plug-ins do navegador</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>Plug-in MS Word</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="checkmark icon">
                            </td>
                        </tr>

                    </table>
                </div>
                <div class="disclaimerContainer disclaimerContainer_table">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="disclaimercontents">
                                    <p>Criamos esses gráficos de comparação para ajudar alunos, professores, bibliotecários
                                        e educadores a tomar uma decisão informada sobre qual gerador de referência é mais
                                        adequado para suas necessidades. Se cometemos um erro neste gráfico, ou esquecemos
                                        de mencionar algo, envie-nos um
                                        <a href="mailto:support@trinka.ai">e-mail</a> e iremos corrigi-lo.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="try_trinka_Buttons">
                    <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Use a Trinka gratuitamente</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="pricing_plan">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="pricing_plan_tables">
                    <h2>Preços dos Planos</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Compare todos os recursos e veja por si mesmo! Trinka não é apenas um verificador gramatical comum. É
                        a ferramenta ideal para redação acadêmica e técnica.
                    </p>
                </div>
                <div class="compare_tabels table-responsive">
                    <div class="pricing_plan_details">
                        <div class="pricing_details">
                            <div class="plan_name">
                                <div class="plan_name_left">
                                    <label>Trinka
                                        <br>Free</label>
                                    <div class="pricing">
                                        <div class="price">
                                            $0
                                            <b>/ month</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan_name_right">
                                    <img src="../../../assets/images/trinka-logo.png" alt="trinka logo" width="136">
                                </div>
                            </div>
                            <ul>
                                <li>Verificações Ortográficas Contextuais</li>
                                <li>Verificações Gramaticais Avançadas</li>
                                <li>Correções De Tom De Escrita</li>
                                <li>Correções Nas Estruturas De Sentenças</li>
                                <li>Aprimoramentos De Impacto De Escrita</li>
                                <li>Edição Automática De Arquivo</li>
                                <li>Escolha Técnica De Palavras</li>
                                <li>Preferências Do Guia De Estilo</li>
                                <li>Verificações De Consistência</li>
                                <li>Verificação de Plágio</li>
                                <li>Verificador de Citações</li>
                                <li>Redação Pronta para Publicação
                                    <br>
                                    <small>(Frase Técnica, Redução Da Contagem De Palavras etc.)</small>
                                </li>
                                <li>Preparação para Publicação em Periódicos
                                    <br>
                                    <small>(Verificação Do Escopo Do Periódico, Resume De Artigo etc.)</small>
                                </li>
                            </ul>
                        </div>
                        <div class="pricing_details">
                            <div class="plan_name">
                                <div class="plan_name_left">
                                    <label>Grammarly Premium</label>
                                    <div class="pricing">
                                        <div class="price">
                                            $12
                                            <b>/ month</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan_name_right">
                                    <img src="../../../assets/images/grammarly-logo.png" alt="grammarly-logo" width="150px">
                                </div>
                            </div>

                            <ul>
                                <li>Ortografia</li>
                                <li>Gramática, Pontuação e Fluência</li>
                                <li>Ajustes de tom</li>
                                <li>Reescritas de frases com foco na clareza</li>
                                <li>Exemplo de reescrita de frases</li>
                                <li>Reescrever frases automaticamente.</li>
                                <li>Escolha de palavras</li>
                                <li>Sugestões avançadas adicionais</li>
                            </ul>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="trinkaBetterThanOthers">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="betterThenContent">
                    <h2>Como a Trinka é melhor do que outras ferramentas de verificação gramatical, como Grammarly</h2>
                    <div class="HeadingSubLine"></div>
                    <p>A escrita avançada precisa de verificações avançadas e a Trinka faz tudo isso por você! A Trinka é um
                        verificador gramatical e ferramenta de correção de linguagem com base em IA, especialmente projetado
                        para redação formal e técnica.
                    </p>
                    <p>Trinka vem com ferramentas integradas avançadas que não apenas verificam sua gramática, ortografia e
                        pontuação, mas também melhoram sua redação para aumentar suas chances de sucesso na publicação. </p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="betterThenImg">
                    <img src="../../../assets/images/BetterThen_img.png" alt="better than">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area">
                        <h3>Área de Assunto e Tipo de Documento</h3>
                    </div>
                    <p>Personalize a Trinka para fornecer as sugestões mais relevantes com base em sua área de assunto e tipo
                        de manuscrito.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="style guide">
                        <h3>Preferências do guia de estilo</h3>
                    </div>
                    <p>Adapte a gramática e a escolha das palavras do seu manuscrito para cumprir os guias de estilo acadêmico
                        populares (AMA 11th, AGU 2017).</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/autoFileEdit_icon.svg" alt="auto edit">
                        <h3>Edição automática de arquivo</h3>
                    </div>
                    <p>Carregue seu documento do MS Word e relaxe enquanto a Trinka o edita automaticamente em minutos. Você
                        pode então fazer o download e finalizá-lo.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/Icon_PublicationChecks.png" alt="Publication Checks" style="max-width: 30px;">
                        <h3>Verificações de preparação para publicação</h3>
                    </div>
                    <p>Avalie seu documento em mais de 20 pontos de verificação, que vão desde Seleção de Periódicos até Conformidade
                        Ética, para aumentar suas chances de ser publicado.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards commingSoonTag">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/ConsistencyCheck_icons.png" alt="Consistency Check" style="max-width: 30px;">
                        <h3>Verificações de consistência</h3>
                    </div>
                    <p>A verificação de consistência da Trinka detecta 6 tipos de inconsistências em sua escrita, não importa
                        o comprimento, e permite que você resolva todas elas com um clique.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/DownloadTrackChangesEdit_icon.png" alt="download changes" style="max-width: 22px;">
                        <h3>Baixar arquivo de alterações de controle</h3>
                    </div>
                    <p>Baixe e finalize um arquivo de mudanças de trilha mostrando as várias mudanças que você selecionou no
                        editor Trinka.</p>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="professionalAcademic">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2>Correções gramaticais acadêmicas e técnicas
                    <br>profissionais em ação
                </h2>
                <div class="HeadingSubLine"></div>
                <p>A Trinka AI realiza mais de 3000 verificações gramaticais, aprimoramentos de tom e estilo, dicas avançadas
                    de redação e, o mais importante, trabalha em todos os assuntos relacionados à redação acadêmica e técnica.</p>
                <div class="grammarCorrectionSlide">

                    <div class="grammarCorrectionMain">

                        <!-- <div class="sliderHeading">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly-logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The beautiful part of this writing assistant, is one it works very fast
                                                            quickly, secondly second it doesn’t <b>requires</b>&nbsp;
                                                            <span>require</span> any effort from the writer.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The beautiful part of this writing assistant, is one it works <b>very
                                                                fast</b>&nbsp;<span>quickly,</span> secondly second it <b>doesn’t
                                                                requires</b>&nbsp;<span>does not require</span> any effort from the
                                                            writer.</p>
                                                    </div>
                                                </div>
                                            </div>
            
                                        </div>
                                    </div> -->
                        <div class="carousel slide" id="keyBenefitContentTwo" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#keyBenefitContentTwo" data-slide-to="0" class="active"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="1"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="2"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="3"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="4"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="5"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="6"></li>
                            </ol>

                            <div class="carousel-inner">

                                <div class="carousel-item active">
                                    <div class="original-text">
                                        <i>Texto Original</i>
                                        <p>Brazilian soils has low levels of phosphorus available, due to high acidity, therefore,
                                            are fundamental the application of phosphate fertilizers for high yields.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly-logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low
                                                            <b>levels of</b> phosphorus
                                                            <span>levels</span> available
                                                            <b>,</b> due to high acidity, therefore, are fundamental the application
                                                            of phosphate fertilizers for high yields.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low levels of phosphorus
                                                            <b>available, due to </b>&nbsp;
                                                            <span>because of</span> high acidity,
                                                            <span>and </span>therefore, are fundamental
                                                            <span>to</span> the application of phosphate fertilizers for high yields.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>Texto Original</i>
                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply, is a major cause
                                            of death and affect annually approximately 795,000.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly-logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and
                                                            <b>affect</b>&nbsp;
                                                            <span>affects</span>&nbsp;annually approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and
                                                            <b>affect annually </b>&nbsp;
                                                            <span>annually affects </span> approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>Texto Original</i>
                                        <p>The depleted proteins were finally digested by trypsin at a protein/trypsin ratio
                                            (w/w) of 50:1 at 37°C for overnight.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly-logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The depleted proteins were finally digested by trypsin at a protein/trypsin
                                                            ratio (w/w) of 50:1 at 37°C for overnight.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The depleted proteins were finally digested
                                                            <b>by</b>&nbsp;
                                                            <span>with</span> trypsin at a protein/trypsin ratio (w/w) of 50:1
                                                            at 37°C
                                                            <b>for</b> overnight.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>Texto Original</i>
                                        <p>Belladonna leaves as well as all other studied leaves contains two distinct phosphatase
                                            fraction belonging to types II and III.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly-logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Belladonna leaves, as well as all other studied leaves
                                                            <span>,</span>
                                                            <b>contains</b>
                                                            <span>contain</span>
                                                            &nbsp;two distinct phosphatase
                                                            <b>fraction</b>
                                                            <span>fractions</span> belonging to types II and III. </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Belladonna leaves
                                                            <b>as well as all</b>&nbsp;
                                                            <span>and </span> other
                                                            <b>studied</b> leaves
                                                            <span>being studied </span>
                                                            <b>contains</b>
                                                            <span>contain</span>&nbsp;two distinct phosphatase
                                                            <b>fraction</b>
                                                            <span>fractions </span>belonging to types II and III.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>Texto Original</i>
                                        <p>He sees signs of long term starvation, worse even than what he saw in Arkansas.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly-logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>He sees signs of
                                                            <span>long term</span>
                                                            <b>long-term</b> starvation, worse even than what he saw in Arkansas.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>He sees signs of
                                                            <span>long term</span>
                                                            <b>long-term</b> starvation,
                                                            <span>even</span> worse
                                                            <b>even</b> than what he saw in Arkansas.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>Texto Original</i>
                                        <p>This kind of political torn-foolery has to a considerable extend prevented our movies
                                            from examining the actual problems of success.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly-logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>This kind of political torn-foolery has to a considerable extend
                                                            prevented our movies from examining the actual problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>
                                                            <b>This kind of</b>
                                                            <span>Such</span> political
                                                            <b>torn-foolery</b>
                                                            <span>tomfoolery</span> has to a considerable
                                                            <b>extend</b>
                                                            <span>extent</span> prevented our movies from examining the actual
                                                            problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>Texto Original</i>
                                        <p>The results shows 234 differently expressed proteins (DEP) between GBM to normal
                                            brain tissues.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly-logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The results
                                                            <b>shows</b>
                                                            <span>show</span> 234 differently expressed proteins (DEP) between
                                                            GBM to normal brain tissues.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The results
                                                            <b>shows</b>
                                                            <span>show</span> 234
                                                            <b>differently</b>
                                                            <span>differentially</span> expressed proteins (
                                                            <b>DEP</b>
                                                            <span>DEPs</span>) between GBM
                                                            <b>to</b>
                                                            <span>and</span>&nbsp;normal brain
                                                            <b>tissues</b>
                                                            <span>tissue</span>.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="compare_top_tools">
    <div class="container">
        <div class="row">
            <div class="col-lg-5">
                <div class="top_tools_image">
                    <img src="../../../assets/images/top_tools_compare.png" alt="tools compare">
                </div>
            </div>
            <div class="col-lg-7">
                <div class="top_tools_text_contents">
                    <div class="howItWorkHeading lineWhiteColor">
                        <h3>Trinka vs. Ferramentas de verificação gramatical líderes</h3>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <p>Como a Trinka se destaca como a autêntica alternativa Grammarly em comparação com as principais ferramentas
                        gramaticais? Testamos em 5.778 palavras de cinco domínios acadêmicos com Grammarly Premium e LanguageTool
                        para verificar a precisão das correções, preferências do guia de estilo, concisão e verificações
                        ortográficas contextuais - todas cruciais para a redação formal e técnica. Para uma comparação detalhada,
                        verifique nosso white paper exclusivo.</p>
                    <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']">
                        Download do Artigo
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="meetTrinka_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>A escrita avançada requer verificações avançadas. Conheça a Trinka.</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="meetTrinkaCard">
                    <div class="meetTrinka_img">
                        <img src="../../../assets/images/GoBeyondGrammar&Spelling.svg" alt="grammar spelling">
                    </div>
                    <h3>Vai além da gramática e da ortografia</h3>
                    <p>A Trinka é mais do que apenas um verificador gramatical; é o seu assistente de redação pessoal que encontra
                        erros complicados de redação acadêmica que outras ferramentas não encontram.</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard unmatched_sections">
                    <div class="meetTrinka_img">

                        <img src="../../../assets/images/UnmatchedWritingEnhancements.svg" alt="writing enhancement">
                    </div>
                    <h3>Aprimoramentos de escrita incomparáveis</h3>
                    <p>A Trinka aprimora o tom, a entrega e o fraseado de sua escrita de acordo com os padrões de publicação
                        acadêmica.
                    </p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard learnAndHelps">
                    <div class="meetTrinka_img">
                        <img src="../../../assets/images/Learns&HelpsYou.svg" alt="learning">
                    </div>
                    <h3>Ajuda você a se tornar um escritor melhor</h3>
                    <p>A Trinka oferece explicações detalhadas, sugestões e dicas de redação para ajudá-lo a aprender enquanto
                        aprimora sua redação.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="meetTrinka_sections switchToTrinka padt0" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>Mudar do Grammarly Premium</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Você já se inscreveu no Grammarly premium, mas está procurando uma alternativa melhor? Você pode facilmente
                        mudar seu saldo Grammarly Premium para Trinka Premium!</p>
                    <p>Mude para a Trinka agora e tenha acesso a correções gramaticais avançadas e dezenas de outros recursos
                        projetados especificamente para redação acadêmica e técnica.</p>
                    <p>Siga 3 passos fáceis agora.
                    </p>
                </div>
            </div>
        </div>
        <div class="key_takewaye_sections">
            <h2>Como funciona?</h2>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>1</p>
                        </div>
                        <div class="need_cards_body">
                            <p>Clique em
                                <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">"Cadastre-se gratuitamente"</a> para criar sua conta. Você poderá acessar uma variedade de
                                recursos exclusivos para redação acadêmica e técnica.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>2</p>
                        </div>
                        <div class="need_cards_body">
                            <p>Selecione "Atualizar" para se inscrever no Trinka premium. Escolha o plano anual e efetue o pagamento.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>3</p>
                        </div>
                        <div class="need_cards_body">
                            <p>Compartilhe seus detalhes de transação Grammarly Premium em
                                <a href="mailto:support@trinka.ai">support@trinka.ai</a> para mudar seu saldo Grammarly Premium para a Trinka premium. </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>



<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>Comece a escrever melhor com a Trinka.</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>Cadastre-se gratuitamente</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="other_comparision">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Ginger</h3>
                    </div>
                    <p>Melhore a escrita além da gramática e verificação ortográfica com Trinka.
                    </p>
                    <a [routerLink]="['/trinka-vs-ginger']">Veja mais informação
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. LanguageTool</h3>
                    </div>
                    <p>Garanta o aprimoramento holístico da linguagem com a Trinka.</p>
                    <a [routerLink]="['/trinka-vs-languagetool']">Veja mais informação
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Writefull</h3>
                    </div>
                    <p>Combine convenções de redação acadêmica e melhores práticas com Trinka.</p>
                    <a [routerLink]="['/trinka-vs-writefull']">Veja mais informação
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="disclaimerContainer">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="disclaimercontents">
                    <p>
                        <span>Isenção de responsabilidade:</span> Todos os nomes de produtos e empresas são marcas comerciais ™
                        ou marcas registradas® de seus respectivos proprietários. Seu uso não implica qualquer afiliação
                        ou endosso por parte deles. Observe que todas as comparações aqui mencionadas foram compiladas com
                        base nas informações do produto disponíveis nos folhetos / sites dos produtos e em testes reais em
                        condições semelhantes em 15 de setembro de 2021. Para qualquer dúvida, entre em contato conosco pelo
                        e-mail
                        <a href="mailto:support@trinka.ai">support@trinka.ai</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>